// Version : 0.0.1
// Author : SABARI
// LastEdit : SABARI
// Last ADD : created service
// MODIFIED DATE : 06-10-2025

import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/********* FETCH ENACH MANDATE REPORT START ******** */
export const fetchENACHMandateReport = (fetchData: any) => {
	const data = {
		EnachMandateReportListToken: fetchData,
	};
	const url = `${API_URL}GeteNACHMandateReportList`;
	return makeApiCall(url, data);
};
/********* FETCH ENACH MANDATE REPORT END ******** */
